import React, { useState } from "react";
import "./GridCommandDepth.scss";

/**
 * Grid Command with Depth - Enhanced version with imagery and visual depth
 */
const GridCommandDepth: React.FC = () => {
    const [selectedGame, setSelectedGame] = useState<string>("all");
    const [searchQuery, setSearchQuery] = useState("");
    const [showGameSelector, setShowGameSelector] = useState(false);

    // Mock game data with image placeholders
    const games = [
        { id: "valorant", name: "Valorant", icon: "🎯", activeQuests: 5, image: "https://via.placeholder.com/400x225/7859E6/FFFFFF?text=Valorant" },
        { id: "fortnite", name: "Fortnite", icon: "🏗️", activeQuests: 8, image: "https://via.placeholder.com/400x225/FF4238/FFFFFF?text=Fortnite" },
        { id: "apex", name: "Apex Legends", icon: "⚡", activeQuests: 4, image: "https://via.placeholder.com/400x225/F7C84C/000000?text=Apex" },
        { id: "cod", name: "Call of Duty", icon: "🔫", activeQuests: 6, image: "https://via.placeholder.com/400x225/1E1E1E/FFFFFF?text=COD" },
        { id: "overwatch", name: "Overwatch 2", icon: "🛡️", activeQuests: 3, image: "https://via.placeholder.com/400x225/FF4238/FFFFFF?text=OW2" },
    ];

    return (
        <div className="grid-command-depth">
            {/* Top Status Bar */}
            <div className="command-header">
                <div className="header-section">
                    <div className="status-indicator status-indicator--online" />
                    <span className="status-text">COMMAND CENTER ONLINE</span>
                </div>

                <div className="header-section">
                    <div className="sync-status">
                        <span className="sync-icon">🔄</span>
                        <span>LAST SYNC: 2 MIN AGO</span>
                    </div>
                </div>

                <div className="header-section">
                    <button className="notification-btn">
                        <span className="notification-icon">🔔</span>
                        <span className="notification-count">3</span>
                    </button>
                </div>
            </div>

            {/* Main Grid Layout */}
            <div className="command-grid">

                {/* LEFT: User Stats Panel */}
                <div className="panel panel--stats">
                    <div className="panel__header">
                        <h3>PILOT PROFILE</h3>
                        <span className="panel__id">#4287</span>
                    </div>

                    <div className="pilot-card">
                        {/* Profile Image Background */}
                        <div className="profile-backdrop">
                            <img src="https://via.placeholder.com/300x150/7859E6/FFFFFF?text=Profile+Banner" alt="Profile backdrop" />
                            <div className="backdrop-gradient" />
                        </div>

                        <div className="pilot-avatar">
                            <div className="avatar-image">
                                <img src="https://via.placeholder.com/100x100/FF4238/FFFFFF?text=Avatar" alt="Avatar" />
                            </div>
                            <div className="level-badge">42</div>
                        </div>

                        <div className="pilot-name">DEATHKILLER99</div>

                        <div className="stat-grid">
                            <div className="stat-item">
                                <span className="stat-value">8,896</span>
                                <span className="stat-label">TOTAL XP</span>
                            </div>
                            <div className="stat-item">
                                <span className="stat-value">1,058</span>
                                <span className="stat-label">FUEL</span>
                            </div>
                            <div className="stat-item">
                                <span className="stat-value">67%</span>
                                <span className="stat-label">WIN RATE</span>
                            </div>
                            <div className="stat-item">
                                <span className="stat-value">12</span>
                                <span className="stat-label">DAY STREAK</span>
                            </div>
                        </div>

                        <div className="achievement-showcase">
                            <div className="showcase-header">RECENT ACHIEVEMENTS</div>
                            <div className="achievement-list">
                                <div className="achievement-card">
                                    <img src="https://via.placeholder.com/80x80/F7C84C/000000?text=Badge" alt="Achievement" />
                                    <span className="achievement-name">SHARPSHOOTER</span>
                                </div>
                                <div className="achievement-card">
                                    <img src="https://via.placeholder.com/80x80/FF4238/FFFFFF?text=Badge" alt="Achievement" />
                                    <span className="achievement-name">SPEED DEMON</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="xp-progression">
                        <div className="xp-header">
                            <span>NEXT LEVEL</span>
                            <span>2,104 XP</span>
                        </div>
                        <div className="xp-bar">
                            <div className="xp-fill" style={{width: "67%"}}>
                                <div className="xp-glow" />
                            </div>
                        </div>
                    </div>

                    <div className="guild-status">
                        <div className="guild-banner">
                            <img src="https://via.placeholder.com/280x80/7859E6/FFFFFF?text=Guild+Banner" alt="Guild banner" />
                            <div className="guild-overlay">
                                <div className="guild-icon">⚔️</div>
                                <div className="guild-info">
                                    <span className="guild-name">APEX PREDATORS</span>
                                    <span className="guild-rank">#7 GLOBAL</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* MIDDLE: Mission Control */}
                <div className="panel panel--missions">
                    {/* Game Selector Bar */}
                    <div className="game-selector-bar">
                        <button
                            className={`game-filter-btn ${selectedGame === "all" ? "active" : ""}`}
                            onClick={() => setSelectedGame("all")}
                        >
                            <span className="filter-icon">🎮</span>
                            <span className="filter-label">ALL GAMES</span>
                            <span className="filter-count">26</span>
                        </button>

                        <div className="selected-game">
                            {selectedGame !== "all" &&
                <div className="game-tag">
                    <span className="game-icon">
                        {games.find(g => g.id === selectedGame)?.icon}
                    </span>
                    <span className="game-name">
                        {games.find(g => g.id === selectedGame)?.name}
                    </span>
                    <button
                        className="game-close"
                        onClick={() => setSelectedGame("all")}
                    >×</button>
                </div>
                            }
                        </div>

                        <button
                            className="game-search-btn"
                            onClick={() => setShowGameSelector(!showGameSelector)}
                        >
                            <span className="search-icon">🔍</span>
                            <span>FIND GAME</span>
                        </button>
                    </div>

                    {/* Game Selector Dropdown */}
                    {showGameSelector &&
            <div className="game-selector-dropdown">
                <input
                    type="text"
                    placeholder="Search games..."
                    className="game-search-input"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
                <div className="game-list">
                    {games
                        .filter(game => game.name.toLowerCase().includes(searchQuery.toLowerCase()))
                        .map(game =>
                            <button
                                key={game.id}
                                className={`game-option ${selectedGame === game.id ? "selected" : ""}`}
                                onClick={() => {
                                    setSelectedGame(game.id);
                                    setShowGameSelector(false);
                                    setSearchQuery("");
                                }}
                            >
                                <img src={game.image} alt={game.name} className="game-thumbnail" />
                                <div className="game-details">
                                    <span className="game-name">{game.name}</span>
                                    <span className="quest-count">{game.activeQuests} quests</span>
                                </div>
                            </button>)}
                </div>
            </div>
                    }

                    {/* Mission Categories */}
                    <div className="mission-categories">
                        <div className="category-tab category-tab--active">
                            <span className="tab-label">GAME QUESTS</span>
                            <span className="tab-count">12</span>
                        </div>
                        <div className="category-tab">
                            <span className="tab-label">BRAND DROPS</span>
                            <span className="tab-count">5</span>
                            <span className="tab-indicator tab-indicator--new" />
                        </div>
                        <div className="category-tab">
                            <span className="tab-label">GUILD OPS</span>
                            <span className="tab-count">3</span>
                        </div>
                    </div>

                    {/* Active Missions */}
                    <div className="mission-grid">
                        {/* Featured Brand Mission - Full Width */}
                        <div className="mission-card mission-card--featured">
                            <div className="mission-backdrop">
                                <img src="https://via.placeholder.com/800x300/FF4238/FFFFFF?text=Brand+Campaign+Hero" alt="Campaign" />
                                <div className="backdrop-gradient" />
                            </div>

                            <div className="mission-content">
                                <div className="brand-header">
                                    <img src="https://via.placeholder.com/120x40/FFFFFF/FF4238?text=Red+Bull" alt="Red Bull" className="brand-logo" />
                                    <span className="brand-tag">EXCLUSIVE DROP</span>
                                </div>

                                <h3 className="mission-title">CLUTCH PLAYS CHALLENGE</h3>
                                <p className="mission-desc">Win 3 matches with less than 10% health remaining</p>

                                <div className="mission-meta">
                                    <div className="mission-games">
                                        <span className="supported-label">Available in:</span>
                                        <div className="game-icons">
                                            <img src="https://via.placeholder.com/30x30/7859E6/FFFFFF?text=V" alt="Valorant" />
                                            <img src="https://via.placeholder.com/30x30/FF4238/FFFFFF?text=A" alt="Apex" />
                                            <img src="https://via.placeholder.com/30x30/F7C84C/000000?text=C" alt="COD" />
                                        </div>
                                    </div>

                                    <div className="mission-rewards">
                                        <div className="reward-card">
                                            <span className="reward-amount">2,500</span>
                                            <span className="reward-type">XP</span>
                                        </div>
                                        <div className="reward-card">
                                            <span className="reward-amount">1,000</span>
                                            <span className="reward-type">FUEL</span>
                                        </div>
                                        <div className="reward-card reward-card--special">
                                            <img src="https://via.placeholder.com/40x40/F7C84C/000000?text=Skin" alt="Reward" />
                                            <span className="reward-type">EXCLUSIVE</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="mission-footer">
                                    <div className="mission-timer">
                                        <span className="timer-icon">⏱️</span>
                                        <span className="timer-text">ENDS IN 2D 14H</span>
                                    </div>
                                    <button className="mission-action mission-action--primary">
                                        START CHALLENGE
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Game-Specific Missions */}
                        <div className="mission-card">
                            <div className="mission-image">
                                <img src="https://via.placeholder.com/350x150/7859E6/FFFFFF?text=Valorant+Quest" alt="Quest" />
                                <div className="game-badge">
                                    <span className="game-icon">🎯</span>
                                    <span className="game-name">VALORANT</span>
                                </div>
                            </div>

                            <div className="mission-body">
                                <h3 className="mission-title">ACE MACHINE</h3>
                                <p className="mission-desc">Get 5 ace rounds in competitive matches</p>

                                <div className="mission-progress">
                                    <div className="progress-stats">
                                        <span>Progress</span>
                                        <span>2/5</span>
                                    </div>
                                    <div className="progress-bar">
                                        <div className="progress-fill" style={{width: "40%"}} />
                                    </div>
                                </div>

                                <div className="mission-rewards">
                                    <div className="reward">
                                        <span className="reward-amount">750</span>
                                        <span className="reward-type">XP</span>
                                    </div>
                                    <div className="reward">
                                        <span className="reward-amount">200</span>
                                        <span className="reward-type">FUEL</span>
                                    </div>
                                </div>
                            </div>

                            <button className="mission-action">CONTINUE</button>
                        </div>

                        <div className="mission-card">
                            <div className="mission-image">
                                <img src="https://via.placeholder.com/350x150/FF4238/FFFFFF?text=Fortnite+Quest" alt="Quest" />
                                <div className="game-badge">
                                    <span className="game-icon">🏗️</span>
                                    <span className="game-name">FORTNITE</span>
                                </div>
                            </div>

                            <div className="mission-body">
                                <h3 className="mission-title">BUILDER PRO</h3>
                                <p className="mission-desc">Build 1000 structures in Battle Royale</p>

                                <div className="mission-progress">
                                    <div className="progress-stats">
                                        <span>Progress</span>
                                        <span>847/1000</span>
                                    </div>
                                    <div className="progress-bar">
                                        <div className="progress-fill" style={{width: "84.7%"}} />
                                    </div>
                                </div>

                                <div className="mission-rewards">
                                    <div className="reward">
                                        <span className="reward-amount">500</span>
                                        <span className="reward-type">XP</span>
                                    </div>
                                </div>
                            </div>

                            <button className="mission-action">CONTINUE</button>
                        </div>

                        {/* Daily Mission */}
                        <div className="mission-card mission-card--daily">
                            <div className="mission-badge">
                                <span className="badge-icon">📅</span>
                                <span className="badge-label">DAILY QUEST</span>
                            </div>

                            <div className="mission-body">
                                <h3 className="mission-title">FIRST BLOOD</h3>
                                <p className="mission-desc">Get the first kill in any match</p>

                                <div className="mission-checklist">
                                    <div className="checklist-item checklist-item--done">
                                        <img src="https://via.placeholder.com/24x24/7859E6/FFFFFF?text=V" alt="Valorant" />
                                        <span>Valorant</span>
                                        <span className="check-icon">✓</span>
                                    </div>
                                    <div className="checklist-item">
                                        <img src="https://via.placeholder.com/24x24/F7C84C/000000?text=A" alt="Apex" />
                                        <span>Apex Legends</span>
                                        <span className="check-icon">○</span>
                                    </div>
                                    <div className="checklist-item">
                                        <img src="https://via.placeholder.com/24x24/1E1E1E/FFFFFF?text=C" alt="COD" />
                                        <span>Call of Duty</span>
                                        <span className="check-icon">○</span>
                                    </div>
                                </div>

                                <div className="mission-rewards">
                                    <div className="reward">
                                        <span className="reward-amount">250</span>
                                        <span className="reward-type">XP</span>
                                    </div>
                                </div>
                            </div>

                            <div className="mission-timer mission-timer--urgent">
                                <span className="timer-icon">⏱️</span>
                                <span className="timer-text">RESETS IN 4H</span>
                            </div>
                        </div>

                        {/* Guild Mission */}
                        <div className="mission-card mission-card--guild">
                            <div className="guild-banner-mini">
                                <img src="https://via.placeholder.com/350x80/7859E6/FFFFFF?text=Guild+Mission" alt="Guild" />
                                <div className="guild-overlay-mini">
                                    <span className="badge-icon">⚔️</span>
                                    <span className="badge-label">GUILD OP</span>
                                </div>
                            </div>

                            <div className="mission-body">
                                <h3 className="mission-title">SQUAD SYNERGY</h3>
                                <p className="mission-desc">Win 10 matches with full guild squad</p>

                                <div className="guild-progress">
                                    <div className="progress-stats">
                                        <span>Guild Progress</span>
                                        <span>7/10</span>
                                    </div>
                                    <div className="progress-bar">
                                        <div className="progress-fill progress-fill--guild" style={{width: "70%"}} />
                                    </div>
                                </div>

                                <div className="contributors">
                                    <span className="contributors-label">Top Contributors:</span>
                                    <div className="contributor-avatars">
                                        <img src="https://via.placeholder.com/30x30/FF4238/FFFFFF?text=S" alt="Sniper" />
                                        <img src="https://via.placeholder.com/30x30/7859E6/FFFFFF?text=P" alt="Pro" />
                                        <img src="https://via.placeholder.com/30x30/F7C84C/000000?text=U" alt="You" />
                                    </div>
                                </div>
                            </div>

                            <button className="mission-action mission-action--guild">JOIN SQUAD</button>
                        </div>
                    </div>
                </div>

                {/* RIGHT: Activity & Quick Actions */}
                <div className="panel-column">
                    {/* Leaderboard Preview */}
                    <div className="panel panel--leaderboard">
                        <div className="panel__header">
                            <h3>TOP PLAYERS</h3>
                            <button className="view-all-btn">FULL BOARD</button>
                        </div>

                        <div className="leaderboard-list">
                            <div className="leaderboard-item leaderboard-item--gold">
                                <span className="rank">1</span>
                                <img src="https://via.placeholder.com/40x40/F7C84C/000000?text=1" alt="Player" className="player-avatar" />
                                <div className="player-info">
                                    <span className="player-name">xXSniperXx</span>
                                    <span className="player-xp">15,234 XP</span>
                                </div>
                            </div>
                            <div className="leaderboard-item leaderboard-item--silver">
                                <span className="rank">2</span>
                                <img src="https://via.placeholder.com/40x40/C0C0C0/000000?text=2" alt="Player" className="player-avatar" />
                                <div className="player-info">
                                    <span className="player-name">ProGamer42</span>
                                    <span className="player-xp">14,876 XP</span>
                                </div>
                            </div>
                            <div className="leaderboard-item leaderboard-item--bronze">
                                <span className="rank">3</span>
                                <img src="https://via.placeholder.com/40x40/CD7F32/FFFFFF?text=3" alt="Player" className="player-avatar" />
                                <div className="player-info">
                                    <span className="player-name">DeadEye</span>
                                    <span className="player-xp">14,102 XP</span>
                                </div>
                            </div>
                            <div className="leaderboard-item leaderboard-item--you">
                                <span className="rank">42</span>
                                <img src="https://via.placeholder.com/40x40/7859E6/FFFFFF?text=U" alt="You" className="player-avatar" />
                                <div className="player-info">
                                    <span className="player-name">You</span>
                                    <span className="player-xp">8,896 XP</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Quick Actions with Images */}
                    <div className="panel panel--actions">
                        <div className="panel__header">
                            <h3>QUICK ACTIONS</h3>
                        </div>

                        <div className="action-grid">
                            <button className="action-card action-card--primary">
                                <div className="action-bg">
                                    <img src="https://via.placeholder.com/150x100/FF4238/FFFFFF?text=Play" alt="Play" />
                                    <div className="action-overlay" />
                                </div>
                                <div className="action-content">
                                    <div className="action-icon">🎮</div>
                                    <div className="action-label">PLAY NOW</div>
                                </div>
                            </button>

                            <button className="action-card">
                                <div className="action-bg">
                                    <img src="https://via.placeholder.com/150x100/7859E6/FFFFFF?text=Loot" alt="Loot" />
                                    <div className="action-overlay" />
                                </div>
                                <div className="action-content">
                                    <div className="action-icon">🎁</div>
                                    <div className="action-label">LOOT BOXES</div>
                                    <div className="action-badge">2</div>
                                </div>
                            </button>

                            <button className="action-card">
                                <div className="action-bg">
                                    <img src="https://via.placeholder.com/150x100/F7C84C/000000?text=Shop" alt="Shop" />
                                    <div className="action-overlay" />
                                </div>
                                <div className="action-content">
                                    <div className="action-icon">🛍️</div>
                                    <div className="action-label">FUEL SHOP</div>
                                </div>
                            </button>

                            <button className="action-card">
                                <div className="action-bg">
                                    <img src="https://via.placeholder.com/150x100/1E1E1E/FFFFFF?text=Guild" alt="Guild" />
                                    <div className="action-overlay" />
                                </div>
                                <div className="action-content">
                                    <div className="action-icon">👥</div>
                                    <div className="action-label">GUILD HQ</div>
                                </div>
                            </button>
                        </div>
                    </div>

                    {/* Upcoming Events with Images */}
                    <div className="panel panel--events">
                        <div className="panel__header">
                            <h3>UPCOMING EVENTS</h3>
                        </div>

                        <div className="event-list">
                            <div className="event-card">
                                <div className="event-image">
                                    <img src="https://via.placeholder.com/280x100/7859E6/FFFFFF?text=Guild+War" alt="Guild War" />
                                    <div className="event-timer">
                                        <span className="timer-value">2H 14M</span>
                                    </div>
                                </div>
                                <div className="event-info">
                                    <div className="event-name">Guild War: Territory Takeover</div>
                                    <div className="event-reward">5000 XP Pool</div>
                                </div>
                            </div>

                            <div className="event-card">
                                <div className="event-image">
                                    <img src="https://via.placeholder.com/280x100/FF4238/FFFFFF?text=Double+XP" alt="Double XP" />
                                    <div className="event-timer">
                                        <span className="timer-value">8H 00M</span>
                                    </div>
                                </div>
                                <div className="event-info">
                                    <div className="event-name">Double XP Weekend</div>
                                    <div className="event-reward">2X All Rewards</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GridCommandDepth;